import React, { useEffect, useRef, useState } from "react"
import { Container, Row, Col, Button } from "react-bootstrap"
import ComboBox from "../../../../components/ComboBox"
import { T部所マスタ } from "../../../../components/ComboBox/BusyoComboBox"
import ConfirmModal from "../../../../components/Modal/ConfirmModal"
import {
  ModalOuter,
  TModalTypes,
} from "../../../../components/Modal/ModalOuter"

import { TWijmoComboBox } from "../../../../type/wijmoComponents"
import { T配車入力Grid } from "./haisyaModalConstants"
import * as wjcInput from "@grapecity/wijmo.input"
import * as wjrInput from "@grapecity/wijmo.react.input"
import {
  get車輌itemsSourceFunctionByApi,
  get乗務員ItemsSourceByApi,
} from "../../../../ts/util/autoCompleteUtil"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import SyaryoSearchModal from "../../../../components/SearchModal/SyaryoSearchModal"
import { THaisyaPostTukekaeReq } from "../../../../service/order/haisya/THaisya"
import { TSyaryoModalList } from "../../../../service/truck/TSyaryo"
import { TZyomuinListItem } from "../../../../service/driver/TZyomuin"
import ZyomuinSearchModal from "../../../../components/SearchModal/ZyomuinSearchModal"

const OrosiChangeModal: React.FC<
  Omit<TModalTypes, "title"> & {
    parentData?: T配車入力Grid
    部所ItemsSource: T部所マスタ[]
    setTukekae: (req: THaisyaPostTukekaeReq) => Promise<unknown>
  }
> = (props) => {
  const [親運行部所コード, set親運行部所コード] = useState(
    props.parentData?.運行部所コード
  )

  const 運行部所コードRef = useRef<string>()
  const pre車番Ref = useRef<string | null>()
  const pre乗務員名Ref = useRef<string | null>()

  //#region [state]

  const [運行部所コード, set運行部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)
  const [車輌ID, set車輌ID] = useState<number>()
  const [車番, set車番] = useState<string>()

  const [乗務員コード, set乗務員コード] = useState<string>()
  const [乗務員名, set乗務員名] = useState<string>()

  // comboBox
  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所isLoadEnded, set部所isLoadEnded] = useState<boolean>(false)

  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [is車輌検索Modal, setIs車輌検索Modal] = useState(false)

  // 乗務員検索
  const [is乗務員検索Modal, setIs乗務員検索Modal] = useState(false)

  const [isDisabled, setIsDisabled] = useState(true)
  //#endregion

  //#region [method]

  const getSyaryoItemsSource: wjcInput.IGetItems = async (
    query: string,
    max: number,
    callback: wjcInput.IGetItemsCallback
  ) => {
    const 部所コード = 運行部所コードRef.current ?? ""

    if (部所コード === "") {
      callback([])
      return
    }
    get車輌itemsSourceFunctionByApi(query, max, callback, 1, 部所コード)
  }

  const getZyomuinItemsSource: wjcInput.IGetItems = async (
    query: string,
    max: number,
    callback: wjcInput.IGetItemsCallback
  ) => {
    const 部所コード = 運行部所コードRef.current ?? ""

    if (部所コード === "") {
      callback([])
      return
    }
    get乗務員ItemsSourceByApi(query, max, callback, 部所コード)
  }

  const setTukekae = () => {
    props
      .setTukekae({
        更新日時: props.parentData!.更新日時!,
        運行部所コード: 運行部所コード!,
        車輌ID,
        乗務員コード,
      })
      .finally(() => {
        setIsConfirmModalShow(false)
      })
  }

  //#endregion

  //#region [effect]

  useEffect(() => {
    set親運行部所コード(props.parentData?.運行部所コード)
  }, [props.parentData])

  useEffect(() => {
    // 別部所に付替えの際に車輌や乗務員が入力されていた場合登録不可
    if (
      props.parentData?.運行部所コード !== 運行部所コード &&
      (車輌ID != null || 乗務員コード != null)
    ) {
      setIsDisabled(true)
    } else if (運行部所コード == null || 運行部所コード === "") {
      setIsDisabled(true)
    } else {
      setIsDisabled(false)
    }
  }, [props.parentData, 運行部所コード, 車輌ID, 乗務員コード])

  //#endregion

  //#region [JSXElement]
  return (
    <>
      <ModalOuter
        isShow={props.isShow}
        title={"卸地車輛変更"}
        setIsShow={props.setIsShow}
        dialogClassName={"w-40rem"}
        footer={
          <>
            <Button
              disabled={isDisabled}
              onClick={() => {
                setIsConfirmModalShow(true)
              }}>
              登録
            </Button>
          </>
        }>
        <Container>
          <Row>
            <Col>
              <table>
                <tbody>
                  <tr>
                    <th>分割先部所</th>
                    <td>
                      <div className="w-20rem">
                        <ComboBox.Busyo
                          placeholder="運行部所"
                          isLoadEnded={部所isLoadEnded}
                          setIsLoadEnded={set部所isLoadEnded}
                          lostFocus={() => {
                            // 親と違う運行部所を選択していた場合、選択している部所を削除する
                            if (運行部所コード !== 親運行部所コード) {
                              set車番("")
                              set車輌ID(undefined)
                            }
                          }}
                          isAllSelect={false}
                          isEmpty={true}
                          isRequired={true}
                          listFilter={(item) => item.運行部所フラグ === 1}
                          itemsSource={props.部所ItemsSource}
                          selectedValue={運行部所コード}
                          setSelectedValue={(v) => {
                            運行部所コードRef.current = v ?? undefined
                            set運行部所コード(v)
                          }}
                          ComboBox={部所ComboBox}
                          setComboBox={set部所ComboBox}></ComboBox.Busyo>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>分割先車輌</th>
                    <td>
                      <div className="d-flex">
                        {/* TODO:将来的には 単独コンポーネント化を視野 */}
                        <wjrInput.AutoComplete
                          className="w-10rem"
                          headerPath={"車番"}
                          minLength={1}
                          text={車番}
                          isDisabled={運行部所コード !== 親運行部所コード}
                          showDropDownButton={false}
                          gotFocus={(control: wjcInput.AutoComplete) => {
                            pre車番Ref.current = control.text
                            control.itemsSourceFunction = getSyaryoItemsSource
                          }}
                          lostFocus={(control: wjcInput.AutoComplete) => {
                            const data: TSyaryoModalList = control.selectedItem
                            if (data) {
                              set車輌ID(data.車輌ID)
                              if (data.乗務員ID) {
                                set乗務員名(data.社員氏名)
                                set乗務員コード(data.社員コード)
                              }
                            } else {
                              set車番("")
                              set車輌ID(undefined)
                              set乗務員名("")
                              set乗務員コード("")
                            }
                          }}
                          displayMemberPath={"displayName"}
                          selectedValuePath={"車番"}></wjrInput.AutoComplete>
                        <button
                          type="button"
                          disabled={運行部所コード !== 親運行部所コード}
                          className="icon-button"
                          onClick={(e) => {
                            e.preventDefault()
                            setIs車輌検索Modal(true)
                          }}>
                          <FontAwesomeIcon
                            className="icon-button-inner"
                            icon={faSearch}></FontAwesomeIcon>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>分割先乗務員</th>
                    <td>
                      <div className="d-flex">
                        {/* TODO:将来的には 単独コンポーネント化を視野 */}
                        <wjrInput.AutoComplete
                          className="w-10rem"
                          headerPath={"社員氏名"}
                          text={乗務員名}
                          isDisabled={
                            運行部所コード !== 親運行部所コード ||
                            車輌ID == null
                          }
                          showDropDownButton={false}
                          gotFocus={(control: wjcInput.AutoComplete) => {
                            pre乗務員名Ref.current = control.text
                            control.itemsSourceFunction = getZyomuinItemsSource
                          }}
                          lostFocus={(control: wjcInput.AutoComplete) => {
                            const data: TZyomuinListItem = control.selectedItem
                            if (data) {
                              set乗務員名(data.社員氏名)
                              set乗務員コード(data.社員コード)
                            } else {
                              set乗務員名("")
                              set乗務員コード(undefined)
                            }
                          }}
                          displayMemberPath={"displayName"}
                          selectedValuePath={
                            "社員氏名"
                          }></wjrInput.AutoComplete>
                        <button
                          type="button"
                          disabled={運行部所コード !== 親運行部所コード}
                          className="icon-button"
                          onClick={(e) => {
                            e.preventDefault()
                            setIs乗務員検索Modal(true)
                          }}>
                          <FontAwesomeIcon
                            className="icon-button-inner"
                            icon={faSearch}></FontAwesomeIcon>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>
        </Container>
      </ModalOuter>

      <SyaryoSearchModal
        setIsShow={setIs車輌検索Modal}
        isBusyoComboBoxReadOnly={true}
        isShow={is車輌検索Modal}
        busyoCode={運行部所コード ?? undefined}
        原動機有無フラグ={1}
        setSyaryo={(車輌) => {
          set車輌ID(車輌.車輌ID)
          set車番(車輌.車番)
          if (車輌.乗務員ID) {
            set乗務員名(車輌.社員氏名)
            set乗務員コード(車輌.社員コード)
          }
        }}></SyaryoSearchModal>
      {/* 乗務員検索 */}
      <ZyomuinSearchModal
        isShow={is乗務員検索Modal}
        setIsShow={setIs乗務員検索Modal}
        busyoCode={運行部所コード ?? undefined}
        isBusyoReadOnly={true}
        setZyomuin={(乗務員) => {
          set乗務員名(乗務員.社員氏名)
          set乗務員コード(乗務員.社員コード)
        }}></ZyomuinSearchModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={setTukekae}>
        <div>受注No:{props.parentData?.受注No}の卸車輛変更を行いますか？</div>
        <div>編集中の情報は反映されません。</div>
      </ConfirmModal>
    </>
  )
  //#endregion
}

export default OrosiChangeModal
